import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=b9535414&scoped=true&"
var script = {}
import style0 from "./Info.vue?vue&type=style&index=0&id=b9535414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9535414",
  null
  
)

export default component.exports